import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Grid, Paper } from '@material-ui/core';
import AccountDetails from './AccountDetails';
import PaymentMethodPreview from './PaymentMethodPreview';
import PaymentSummaryPreview from './PaymentSummaryPreview';
import PersonalInformationPreview from './PersonalInformationPreview';
import TransactionsPreview from './TransactionsPreview';

const styles = (theme) => ({
  root: {},
  topGrid: {
    backgroundColor: '#ffffff',
  },
  actionButton: {
    marginRight: 10,
  },
  overview: {
    paddingBottom: theme.spacing(4),
  },
});

class CustomerDetails extends React.Component {
  render() {
    const { classes, customerDetails, localisation } = this.props;
    return (
      <div>
        <Grid container className={classes.root} spacing={3}>
          <Grid item xs={12}>
            <Paper className={classes.overview}>
              <Grid container>
                <Grid item xs={12} md={4}>
                  <AccountDetails
                    customerDetails={customerDetails}
                    localisation={localisation}
                  />
                </Grid>
                <Grid item xs={12} md={8}>
                  <PaymentSummaryPreview
                    customerDetails={customerDetails}
                    localisation={localisation}
                  />
                </Grid>
              </Grid>
            </Paper>
          </Grid>
          <Grid item xs={12} md={4} lg={4}>
            <PersonalInformationPreview
              customerDetails={customerDetails}
              localisation={localisation}
            />
          </Grid>
          <Grid item xs={12} md={5} lg={4}>
            <TransactionsPreview
              customerDetails={customerDetails}
              localisation={localisation}
            />
          </Grid>
          <Grid item xs={12} md={3} lg={4}>
            <PaymentMethodPreview
              customerDetails={customerDetails}
              localisation={localisation}
            />
          </Grid>
        </Grid>
      </div>
    );
  }
}

CustomerDetails.propTypes = {
  classes: PropTypes.object.isRequired,
  localisation: PropTypes.object,
};

export default withStyles(styles)(CustomerDetails);
